import { useEffect, useState } from "react";
import { Link, useLocation, useSearch } from "wouter";
import { useAuth } from "../lib/auth";
import { AccountNameEditor } from "../components/AccountNameEditor";
import { ResumeModal } from "../components/DashboardProfile";
import { Button } from "../components/beui/Button";
import { Card, CardContent } from "../components/beui/SurfaceCard";

export default function AccountProfile() {
  const { user, loading } = useAuth();
  const [, navigate] = useLocation();
  const search = useSearch();
  const [resumesOpen, setResumesOpen] = useState(() => new URLSearchParams(search).get("field") === "resume");
  useEffect(() => { if (!loading && !user) navigate("/login"); }, [loading, user, navigate]);
  useEffect(() => { if (new URLSearchParams(search).get("field") === "resume") setResumesOpen(true); }, [search]);
  useEffect(()=>{if(!user||loading)return;const frame=requestAnimationFrame(()=>{const target=document.getElementById(resumesOpen?'resume-add-file':'profile-first-name');target?.focus()});return()=>cancelAnimationFrame(frame)},[loading,user?.id,resumesOpen]);
  if (loading || !user) return <p role="status" className="container-x py-12">Loading profile…</p>;
  return <main className="container-x max-w-3xl space-y-4 py-6">
    <Link href="/settings" className="text-sm text-blue-700">← Back to Settings</Link>
    <h1 className="text-2xl font-bold text-navy">Edit profile</h1>
    <AccountNameEditor key={user.id}/>
    <Card size="compact"><CardContent><h2 className="font-bold text-navy">Résumé files</h2><Button variant="outline" className="mt-3 min-h-11" onClick={() => setResumesOpen(true)}>Manage résumés</Button></CardContent></Card>
    {user.capabilities.some(capability => ["find_work", "offer_service"].includes(capability)) && <Link href="/worker-profile" className="btn-outline min-h-11">Edit work profile</Link>}
    <ResumeModal open={resumesOpen} onClose={() => setResumesOpen(false)}/>
  </main>;
}
